import { usePunditUserContext } from "@/react/contexts/punditUserContext";

export const useCanEditCanonicalUrl = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(currentCommunitySettings?.cms_post_canonical_url_enabled);
};
